// extracted by mini-css-extract-plugin
export default {"settings":"PhotoSettings_settings__wZ20v","container":"PhotoSettings_container__r0D9z","images":"PhotoSettings_images__+CsSO","save":"PhotoSettings_save__bkomo"};